<template>
  <div>
    <keep-alive>
    <span class="end-selected-view" @click="handleOpen" v-show="placeholder !== ''">{{endSelected[props.lable] ? endSelected[props.lable] : placeholder}}</span>
    </keep-alive>
    <!-- 多级选择 -->
    <div class="yt-multi-seletor" v-show="visible">
      <div class="yt-selected-view">
        <!-- 已选择列表 -->
        <div class="yt-selected-top-view">
          <div class="yt-selected-top-operate-view">
            <span class="yt-text" @click="handleClose">取消</span>
            <span class="yt-text" @click="handleConfirm">确认</span>
          </div>
          <div
            class="yt-district-item-view"
            v-for="(item, index) in selectedList" :key="index">
            <p class="yt-district-view"
              :class="{'yt-selectedView': (selectedNode.index == index && !selectLowerBtn),'yt-first': index == 0}"
              @click="handleSelect(index, item)">{{item[props.lable]}}</p>
              <!-- @@@{{index}}--{{selectedNode.index}}{{(selectedNode.index == index && !selectLowerBtn)}}++ {{selectLowerBtn}} -->
          </div>
          <div class="yt-district-item-view">
            <p class="yt-district-view yt-selectedView yt-showSelectSub" :class="{'yt-first': selectedList.length == 0}" v-show="selectLowerBtn">{{sText}}</p>
          </div>
        </div>

        <div class="yt-selected-bottom-view">
          <p class="yt-selected-title-view">{{groupTitle}}</p>
          <div class="yt-selected-scrollview">
            <p
              :class="['yt-cell-view', {'active': item[props[value]] === currentSelectNode[props[value]] }]"
              v-for="(item, index) in currentList"
              :key="index"
              @click="handleCurrent(item, index)">{{item[props.lable]}}{{item[props.children] ? '>' : ''}}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
let vm, n = 0
export default {
  name: 'ceshi',
  props: {
    value: {
      type: [String, Number],
      default: '',
      required: true
    },
    data: {
      type: Array,
      default: [],
      required: true
    },
    placeholder: {
      type: String,
      default: ''
    },
    props: {
      type: Object,
      // 对象或数组默认值必须从一个工厂函数获取
      default: function () {
        return {
          value: 'value',
          parent_value: 'parent_value',
          lable: 'lable',
          children: 'children' 
        }
      }
    },
    sText: {
      type: String,
      default: '请选择下一级'
    },
    groupTitle: {
      type: String,
      default: '分组标题'
    }
  },
  data () {
    return {
      visible: false,
      selectedList: [],
      selectedNode: {
        index: 0
      },
      selectLowerBtn: true,

      currentSelectNode: {},
      currentList: [],
      endSelected: {}
    }
  },
  computed: {
  },
  created () {
    vm = this
    vm.getInitList()
    console.log('props', vm)
  },
  methods: {
    // 获取当前默认初始列表
    getInitList () {
      if (vm.value !== '') {
        vm.selectedList = vm.getParent(vm.data, vm.value)
        vm.currentList = vm.getNewCurrentList(vm.data, vm.selectedList[vm.selectedList.length-1][vm.props.parent_value])
        console.log('nowList', vm.selectedList)
        console.log('currentList', vm.currentList)
      }else {
        vm.currentList = vm.data
      }
      console.log('tag', vm.currentList)
    },
    // 确认已选择部门信息
    handleConfirm () {
      console.log('确认已选择列表', vm.selectedList)
      let length = vm.selectedList.length
      if (length !== 0) {
        vm.endSelected = vm.selectedList[ length - 1]
        vm.$emit('update:value', vm.endSelected[vm.props.value])
        vm.$emit('confirm', {detail: vm.selectedList, value: vm.endSelected})
        vm.visible = false
      } else {
        vm.$emit('confirm', {detail: vm.selectedList})
      }
    },
    // 开启选择器
    handleOpen () {
      // console.log('vm.value', vm.value)
      // console.log('vm.data', vm.data)
      vm.visible = true
      if (vm.value !== '') {
        vm.selectedList = vm.getParent(vm.data, vm.value)
        vm.currentList = vm.getNewCurrentList(vm.data, vm.selectedList[vm.selectedList.length-1][vm.props.parent_value])
        // console.log('nowList', vm.selectedList)
        // console.log('currentList', vm.currentList)
      }
    },
    // 获取当前选择的所有父级信息
    getParent(data2, nodeId2) {
      var arrRes = [];
      if (data2.length == 0) {
          if (!!nodeId2) {
              arrRes.unshift(data2)
          }
          return arrRes;
      }
      let rev = (data, nodeId) => {
          for (var i = 0, length = data.length; i < length; i++) {
              let node = data[i];
              if (node[vm.props.value] == nodeId) {
                  arrRes.unshift(node)
                  rev(data2, node[vm.props.parent_value]);
                  break;
              }
              else {
                  if (!!node[vm.props.children]) {
                      rev(node[vm.props.children], nodeId);
                  }
              }
          }
          return arrRes;
      };
      arrRes = rev(data2, nodeId2);
      return arrRes;
    },
    // 关闭选择器
    handleClose () {
      // 隐藏
      vm.visible =  false
      // 重置所有数据
      vm.selectedList = []
      vm.selectedNode.index = 0
      vm.selectLowerBtn = true,
      vm.currentList = vm.data
    },
    // 操作当前显示部门
    handleCurrent (item, index) {
      // console.log('e', item)
      vm.currentSelectNode = item
      let parent_value = vm.props.parent_value
      let selectedList = [...vm.selectedList]
      let length = selectedList.length
      // console.log('selectedList', selectedList.length)
      let isPush = true
      if (length == 0) { isPush = true }
      for (let i = 0; i < length; i++) {
        // console.log('selectedList[i][parent_value]', selectedList[i][parent_value])
        // console.log('item[parent_value]', item[parent_value])
        // console.log('isPush', isPush)
        if (selectedList[i][parent_value] == item[parent_value]) {
          // console.log('125', '')
          vm.selectedList.splice(i, 1, item)
          isPush = false
        }
        // console.log('isPush', isPush)
      }
      // console.log('isPush', isPush)
      if (isPush) {
        vm.selectedList.push(item)
      }
        if (item[vm.props.children]){
          vm.selectLowerBtn = true
          vm.currentList = item[vm.props.children]
          vm.selectedNode.index = vm.selectedNode.index + 1
        } else {
          vm.selectLowerBtn = false
          vm.selectedNode.index = vm.selectedNode.index
        }
      
      console.log('vm.selectedNode.index', vm.selectedNode.index, vm.selectLowerBtn)
      
    },
    // 操作当前已选择部门
    handleSelect (index, item) {
      // console.log(index, item)
      let length = vm.selectedList.length - 1
      vm.selectedList.splice(index + 1, length - index)
      vm.currentList = vm.getNewCurrentList(vm.data, item[vm.props.parent_value])
      vm.selectLowerBtn = item[vm.props.children] ? true : false
      vm.selectedNode = {
        index: index,
        item: item
      }
      // console.log('当前列表', vm.currentList)
    },
    // 获取新的部门列表显示
    getNewCurrentList (list, now_parent_id) {
      for (let i in list) {
      // console.log('now_parent_id', now_parent_id, 'id', list[i][vm.props.value])
        if (now_parent_id == undefined || now_parent_id == 0) {
          return list
        } else if (list[i][vm.props.value] == now_parent_id) {
        // console.log('list[i]', list[i])
          return list[i][vm.props.children]
        } else {
          // 没找到，继续调用此函数
          return vm.getNewCurrentList(list[i][vm.props.children], now_parent_id)
        }
      }
    }
  },
  watch: {
    // 监听列表数据变化
    'data' (newVal, oldVal) {
      // console.log('oldVal', oldVal)
      // console.log('data改变', newVal, oldVal.length === 0 && newVal.length !== 0)
      if (oldVal.length === 0 && newVal.length !== 0) {
        vm.getInitList()
      }
    },
    'visible' (newVal) {
      if (newVal) { vm.getInitList() }
    }
  }
}
</script>  


<style>
.end-selected-view {
  width: 100%;
  /* height: 40px;
  line-height: 40px; */
  color: #333333;
  display: inline-block;
}

/* 层级选择 */
.yt-multi-seletor{
  width: 100%;
  font-size: 16px;
  background-color: rgba(0, 0, 0, 0.6);
  /* background-color: rgb(148, 143, 143);filter:Alpha(Opacity=60);   opacity:0.6; */
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  z-index: 999;
}

.yt-selected-view {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  border-radius: 8px 8px 0 0;
  background-color: #fff;
}

.yt-selected-top-operate-view {
  /* // width: 100%; */
  padding: 0 10px;
  line-height: 50px;
  color: #1189f1;
  border-bottom: 1px solid #f0f0f0;
  display: flex;
  justify-content: space-between;
}

.yt-district-item-view {
  padding-top: 7px;
  display: flex;
  padding: 0 10px;
  /* border-bottom: 1px #66CC99 solid; */
}

.yt-district-view {
  color: #333333;
  padding-left: 20px;
  height: 40px;
  line-height: 40px;
  position: relative;
}

/* 线条 */
.yt-district-view::before {
  display: block;
  content: '';
  width: 1px;
  height: 33px;
  background-color: #1189f1;
  position: absolute;
  left: 0;
  top: -16px;
}

/* 圆点 */
.yt-district-view::after {
  display: block;
  content: '';
  width: 7px;
  height: 7px;
  border-radius: 50%;
  border: 1px solid #1189f1;
  background-color: #1189f1;
  position: absolute;
  left: -3px;
  top: 16px;
}

.yt-district-view.yt-first::before {
  display: none;
}

.yt-district-item-view:first-child .yt-district-view::before {
  display: none;
}

.yt-district-view.yt-showSelectSub::after {
  background-color: #ffffff !important;
}

/* 选中层级的颜色 */

.yt-selectedView {
  color: #1189f1;
}

.yt-selected-bottom-view {
  background-color: whitesmoke;
  border-top: 1px solid #f0f0f0;
  text-align: left;
}

.yt-selected-title-view {
  text-indent: 10px;
  font-size: 14px;
  color: #a3a3a3;
  height: 40px;
  line-height: 40px;
}

.yt-selected-scrollview {
  overflow-x: hidden;
  overflow-y: scroll;
  height: 160px;
  /* background-color: whitesmoke; */
  padding: 0 10px;
}

.yt-cell-view {
  height: 40px;
  line-height: 40px;
  color: #333333;
}

.yt-cell-view.active {
  color: #1189f1;
}

</style>



// WEBPACK FOOTER //
// src/components/PhonePage/ToolApplet/module/multi-selector.vue